import { render, staticRenderFns } from "./HcpWorkPlaceView.vue?vue&type=template&id=24337bfb&"
import script from "./HcpWorkPlaceView.vue?vue&type=script&lang=js&"
export * from "./HcpWorkPlaceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24337bfb')) {
      api.createRecord('24337bfb', component.options)
    } else {
      api.reload('24337bfb', component.options)
    }
    module.hot.accept("./HcpWorkPlaceView.vue?vue&type=template&id=24337bfb&", function () {
      api.rerender('24337bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/livedi/view/HcpWorkPlaceView.vue"
export default component.exports